import { IsOptional, IsString, MaxLength, IsUUID, IsEnum } from 'class-validator';
import { EntityType } from '../../../enums';

export class UpdateEntityContactRequestDto {
    @IsOptional()
    @IsUUID()
    contactId?: string;

    @IsOptional()
    @IsUUID()
    entityId?: string;

    @IsOptional()
    @IsEnum(EntityType)
    entityType?: EntityType;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    roleDescription?: string;

    @IsOptional()
    @IsString()
    @MaxLength(255)
    context?: string;
}
